import { useContext } from 'react';
import { MigrationContext } from '../../context/MigrationContext';

export const useMigrationContext = () => useContext(MigrationContext);
